import { useMutation } from '@tanstack/react-query'
import type { Actor } from '../../api/hub/types'
import { retryFailedNotifications } from '../../api/hub/notifications'

export function NotificationRecovery({ actor }: { actor?: Actor }) {
  const retry = useMutation({ mutationFn: retryFailedNotifications })
  const canRetry = actor && !actor.customerId && !actor.isAI && ['CEO', 'CTO'].includes(actor.role)
  return <fieldset>
    <legend>失败通知恢复</legend>
    <p>点击会让历史未送达且尚未读过的失败通知重新进入投递队列，仅内部人工 CEO、CTO 可操作。每次最多 100 条；重新排队不代表已送达，请核对后续投递结果。</p>
    {canRetry ? <button type="button" disabled={retry.isPending} onClick={() => retry.mutate()}>重新排队失败通知</button> : <p>此操作仅对内部人工管理员开放。</p>}
    {retry.isPending && <p role="status">正在重新排队…</p>}
    {retry.isSuccess && <p role="status">已重新排队 {retry.data.queued} 条失败通知。{retry.data.queued === 0 ? '当前没有符合条件的失败通知。' : '如仍有积压，可在本批处理后再次操作。'}</p>}
    {retry.isError && <p role="alert">重新排队失败：{retry.error.message}</p>}
  </fieldset>
}
